import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isEmpty from 'lodash/isEmpty';
import AmountBifurcation from './AmountBifurcation';
import * as Helper from '../../utils/helper';
import './CartHealthcareContainer.scss';
import DropdownInput from '../DropdownInput';
import ItemMRPInfo from './ItemMRPInfo';
import removeIcon from '../../images/delete.svg';

const CartHealthcareContainer = ({ healthcareList, amountBifurcation, updateCart, onRemove, omsEnabled }) => (
  <div className="CartHealthcareContainer">
    <div className="CartHealthcareHeader">
      <div className="ItemName">Health & Wellness Products</div>
      <div className="ItemQty">Order Qty</div>
      <div className="ItemPrice">Approx. Price</div>
      <div className="ItemRemove" />
    </div>
    <div className="CartHealthcareList">
      {healthcareList.map(item =>
        <CartHealthcareListItem
          key={item.itemId}
          item={item}
          onUpdate={updateCart}
          onRemove={onRemove}
          omsEnabled={omsEnabled}
        />)}
    </div>
    {amountBifurcation[0].value > 0 && <AmountBifurcation invoice={amountBifurcation || []} />}
  </div>
);

CartHealthcareContainer.propTypes = {
  healthcareList: PropTypes.array,
  amountBifurcation: PropTypes.array,
  updateCart: PropTypes.func,
  onRemove: PropTypes.func,
  omsEnabled: PropTypes.bool.isRequired,
};

CartHealthcareContainer.defaultProps = {
  healthcareList: [],
  amountBifurcation: [],
  updateCart: (id, quantity) => console.log('update cart called', id, quantity),
  onRemove: id => console.log('remove from cart', id),
};

export default CartHealthcareContainer;


class CartHealthcareListItem extends Component {

  constructor(props) {
    super(props);
    this.state = {
      quantity: this.props.item.quantity,
      isUpdating: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { item: { quantity } } = nextProps;
    if (quantity !== this.state.quantity) {
      this.setState({ quantity });
    }
  }

  handleItemQtyChange = ({value}) => {
    const {item: { itemId }, onRemove} = this.props;
    this.setState({quantity: value, isUpdating: true});
    if (value === 0) {
      return onRemove(itemId);
    }
    if (value && !isNaN(value)) {
      this.props.onUpdate(itemId, value).then(() => {
        this.setState({isUpdating: false})
      });
    }
  }

  render() {
    const {item, onRemove, omsEnabled} = this.props;
    const { quantity: itemQuantity, isUpdating } = this.state;
    const hasWarnings = !isEmpty(item.warning);
    return (
      <div className={cx("CartHealthcareListItem", {'HasWarning': hasWarnings, 'pe-loading': isUpdating})}>
        <div className="detailsContainer">
          <div className="ItemName">{item.name}</div>
          <div className="ItemQty">
            <DropdownInput
              options={Helper.createItemQtyArray(20)}
              onSelect={this.handleItemQtyChange}
              onChange={({value}) => this.setState({quantity: value})}
              placeholder="Add"
              value={{label: itemQuantity, value: itemQuantity}}
              className="cartMedQty"
              emptyText="Not Allowed"
              pattern={/\d/g}
            />
          </div>
          <div className="ItemPrice">
            <ItemMRPInfo
              discountPercent={item.discountPercent}
              listPriceDecimal={item.mrpDecimal}
              salePriceDecimal={item.salePriceDecimal}
              quantity={item.quantity}
              omsEnabled={omsEnabled}
              isCart
            />
          </div>
          <button className="ItemRemove" onClick={() => onRemove(item.itemId)}>
            <img src={removeIcon} alt="remove" title="remove"/>
          </button>
        </div>
        <div className="eddContainer">
          {!hasWarnings && <div>EDD: {(item.eddDetails && item.eddDetails.edd) ? item.eddDetails.edd.time : 'N/A'}</div>}
          {hasWarnings && item.warning.map(warn => <div className="eddText" key={warn.text}>{warn.text}</div>)}
        </div>
      </div>
    );
  }
}
